import Header from "@/components/common/header";
import {
  createFileRoute,
  Outlet,
  useMatchRoute,
} from "@tanstack/react-router";

export const Route = createFileRoute("/(auth)")({
  component: RouteComponent,
});

function RouteComponent() {
  const matchRoute = useMatchRoute();
  const isGetAppRoute = matchRoute({ to: '/get-app' });
  
  return (
    <div>
      {!isGetAppRoute && <Header />}
      <Outlet />
    </div>
  );
}